<template>
  <div>

    <EmptyCardModal
      v-if="cardCashoutModal"
      ref="modalCard"
      :modalData="cardCashoutModal"
      :onModalClose="(reset) => cardCashoutModal = null"
      :onModalAccept="saveCashOut"
    >
      <slot>
        <template>
          <div>
            <!--            <div class="form-group mr-2">-->
            <!--              <label for="">Выберите карту</label>-->
            <!--              <select v-model="cardCashoutModal.selectedCard" class="form-control">-->
            <!--                <option disablde value="0">Выберите карту</option>-->
            <!--                <option v-for="card in balance.cards.cardsBase" :value="card.id">{{ printNumber(card.number) }}</option>-->
            <!--              </select>-->
            <!--            </div>-->
            <template v-if="!cardCashoutModal.cashOut">
              <div class="flex">
                <div>
                  <p>По заявкам числится: <strong>{{ totalCardsSum.toLocaleString('ru-RU') }}</strong></p>
                  <p>В работе заявки:
                    <strong>{{ (noCashOrders?.ordersInProgress?.total_sum || 0).toLocaleString('ru-RU') }}</strong></p>
                  <p>Зачисление по SMS: <strong>{{ (noCashOrders.incomesBySms || 0).toLocaleString('ru-RU') }}</strong>
                  </p>
                  <p>Баланс на картах: <strong>{{
                      ($refs.cardsBalance?.totalAmount || 0).toLocaleString('ru-RU')
                    }}</strong></p>
                  <p>Снято с карт: <strong>{{ noCashOrders.cashOutSum.toLocaleString('ru-RU') }}</strong></p>
                  <LoadingButton
                    v-if="cardCashoutModal.updateBalance"
                    title="Обновить баланс"
                    type="button"
                    :loading="btnBalanceLoading"
                    :color="$constants.SUCCESS_COLOR"
                    :onClick="() => updateCardsBalance()"
                    className="btn btn-outline-success btn-sx"
                  />
                </div>
                <div class="ml-2 border-left pl-2">
                  <p>{{ totalCardsSum }} + {{ (noCashOrders?.ordersInProgress?.total_sum || 0) }} +
                    {{ noCashOrders.incomesBySms || 0 }} - {{ $refs.cardsBalance?.totalAmount || 0 }} =
                    <strong>{{ getControlSum().toLocaleString('ru-RU') }}</strong></p>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="alert alert-info">
                <p>При снятии суммы <strong>0</strong> - обналичивание будет удалено</p>
              </div>
            </template>
            <div class="form-group">
              <label for="">Сумма снятия</label>
              <div class="input-group">
                <input type="number" v-model="cardCashoutModal.sum" class="form-control">
                <div class="input-group-prepend input-group-append">
                  <span class="input-group-text">{{ getControlSum(true) }}</span>
                </div>
              </div>
            </div>
          </div>
          <!--          <div>-->
          <!--            <p v-if="cardCashoutModal.selectedCard">-->
          <!--              остаток на карте-->
          <!--              <strong>{{-->
          <!--                  ((balance.cards.end && balance.cards.end[cardCashoutModal.selectedCard] || 0) + (balance.cards.start && balance.cards.start[cardCashoutModal.selectedCard] || 0)).toLocaleString('ru-RU')-->
          <!--                }}</strong>-->
          <!--            </p>-->
          <!--          </div>-->
        </template>
      </slot>
    </EmptyCardModal>

    <div v-if="false" class="hidden">
      <p v-for="(bal, curr) in balance.start" v-if="bal.orders">
        Сальдо {{ $AllCurrencies[curr].currency }}: <strong>{{ bal.orders.toLocaleString('ru-RU') }}</strong>
      </p>
      <p>Заявки {{ $AllCurrencies[33].currency }}: <strong>{{
          (orders?.grouped?.total_pass ?? 0).toLocaleString('ru-RU')
        }}</strong></p>
      <template v-if="dayData && dayData.expenses && dayData.expenses.length">
        <p>Расходы:</p>
        <p v-for="exp in dayData.expenses">{{ $AllCurrencies[exp.currency_id].currency }}: <strong>-
          {{ exp.sum.toLocaleString('ru-RU') }}</strong></p>
      </template>
      <template v-if="dayData && dayData.exchanges && dayData.exchanges.length">
        <p>Покупка валют:</p>
        <p v-for="exch in dayData.exchanges">{{ $AllCurrencies[exch.currency_id].currency }}:
          <strong>{{ exch.sum.toLocaleString('ru-RU') }}</strong></p>
      </template>
      <template v-if="useCashOut">
        <p>Конверт {{ $AllCurrencies[33].currency }}:
          <strong>{{ balance.start[33].cash.toLocaleString('ru-RU') }}</strong></p>
        <p>ЗП {{ $AllCurrencies[33].currency }}:
          <strong>{{ (balance.start[33].salary + (orders.grouped.total_salary || 0)).toLocaleString('ru-RU') }}</strong>
        </p>
        <p>Почтовые р. {{ $AllCurrencies[33].currency }}:
          <strong>{{ (balance.start[33].post + (orders.grouped.total_post || 0)).toLocaleString('ru-RU') }}</strong></p>
      </template>
      <template v-if="dayData && dayData.incashmentsData.incashment">
        <hr>
        <p>Снятие: <strong>{{ moment(dayData.incashmentsData.incashment.report_date, 'HH:mm DD.MM.YYYY') }}</strong></p>
        <p>Снятая сумма: <strong>{{ (dayData.incashmentsData.incashment.sum || 0).toLocaleString('ru-RU') }}</strong>
        </p>
        <p>Заявки: <strong>{{ (dayData.incashmentsData.incashment.adm_amount || 0).toLocaleString('ru-RU') }}</strong>
        </p>
        <p>ЗП: <strong>{{ (dayData.incashmentsData.incashment.salary_amount || 0).toLocaleString('ru-RU') }}</strong>
        </p>
        <p>Почтовые р.:
          <strong>{{ (dayData.incashmentsData.incashment.post_amount || 0).toLocaleString('ru-RU') }}</strong></p>
        <p>Конверт: <strong>{{ (dayData.incashmentsData.incashment.cash_amount || 0).toLocaleString('ru-RU') }}</strong>
        </p>
      </template>
      <template v-if="dayData && dayData.incomes && (dayData.incomes.in.length || dayData.incomes.out.length)">
        <p>Инкассации:</p>
        <p v-for="inc in dayData.incomes.in">{{ $AllCurrencies[inc.currency_id].currency }}:
          <strong>{{ inc.sum.toLocaleString('ru-RU') }}</strong>
          ({{ divisions[inc.division_id].user.short_name }} <span
            v-for="(store, i) in divisions[inc.division_id].stores">{{
              i !== 0 ? ', ' : ''
            }}{{ $AllStores[store.object_id].short_title }}</span>)
        </p>
        <p v-for="inc in dayData.incomes.out">{{ $AllCurrencies[inc.currency_id].currency }}: <strong>-
          {{ inc.sum.toLocaleString('ru-RU') }}</strong></p>
      </template>
      <hr>
    </div>
    <div v-if="useCashOut">
      <p v-for="(val, title) in getActualCashData()">{{ titles[title] }}:
        <strong>{{ val.toLocaleString('ru-RU') }}</strong></p>
      <hr>
    </div>
    <div class="figures flex justify-content-between">
      <div>
        <template v-if="+divisionCurrency.id !== 33">
          <p v-for="(b, currId) in (balance.currencyBalance?.balance ?? [])" v-if="+b.amount">
            {{ $AllCurrencies[currId].currency }}: <strong>{{ b.amount.toLocaleString('ru-RU') }}</strong>
            <span v-if="+currId === +divisionCurrency.id">
              ( RUB: ~ {{ getCurrencyBalance(b.amount).toLocaleString('ru-RU') }} )
            </span>
          </p>
        </template>
        <template v-else>
          <p v-for="(val, curr) in getTotalSum()" v-if="val || +curr === divisionCurrency?.id">
            {{ $AllCurrencies[curr].currency }}:
            <strong>{{ val.toLocaleString('ru-RU') }}</strong>
            <!--          <template v-if="$AllDivisions[division]?.settings?.cross_currency_id && +curr === 33">-->
            <!--            ( {{ $AllCurrencies[$AllDivisions[division].settings.currency_id].currency }}-->
            <!--            <strong>{{ getCurrencyBalance().toLocaleString('ru-RU') }}</strong> )-->
            <!--          </template>-->
          </p>
        </template>
      </div>
      <div v-if="false">
        <template
          v-if="$AllDivisions[division].settings && $AllDivisions[division].settings.use_prepaid_cards && totalCardsSum">
          <p class="text-right"><i class="icon-fa icon-fa-credit-card"/>
            <strong>{{ totalCardsSum.toLocaleString("ru-RU") }}</strong></p>
          <p v-if="+division === 1" class="fs-12 text-right">б/н за {{ $route.query.date }}
            <strong>{{ balance?.cards?.end?.totalSum ?? 0 }}</strong> из них регионы
            <strong>{{ +(balance?.cards?.end?.totalSum ?? 0) - +(orders?.grouped?.no_cash_total ?? 0) }}</strong></p>
          <template v-if="balance.cards.end.cardsCashOut">
            <p class="fs-12 text-right">обналичивание: <strong>{{
                balance.cards.end.cardsCashOut.sum.toLocaleString('ru-RU')
              }}</strong>
            </p>
            <p class="text-right"><i class="icon-fa icon-fa-credit-card"/>
              <strong>{{
                  ((balance.cards && balance.cards.start.totalSum || 0) + (balance.cards && balance.cards.end.totalSum || 0) - (balance.cards && balance.cards.end.cardsCashOut.sum || 0)).toLocaleString('ru-RU')
                }}</strong></p>
          </template>
          <div v-if="allowToCashoutCard && !balance.cards.end.cardsCashOut" class="flex">
            <div class="fs-14 mr-2" v-if="allowToCashoutCard && !balance.cards.end.cardsCashOut && noCashOrders">
              <div>
                <v-popover :auto-hide="true" v-if="noCashOrders?.ordersInProgress?.orders.length">
                  <span class="badge badge-info pointer">Заявки</span>
                  <template slot="popover">
                    <div>
                      <p v-for="o in noCashOrders.ordersInProgress.orders">{{ o.id }} ({{ o.price }})</p>
                    </div>
                  </template>
                </v-popover>
                в работе:
                <strong>{{ (noCashOrders?.ordersInProgress?.total_sum || 0).toLocaleString('ru-RU') }}</strong>
              </div>
              <p>Зачисление по SMS: <strong>{{ noCashOrders.incomesBySms.toLocaleString('ru-RU') }}</strong></p>
              <p>Снято с карт: <strong>{{ noCashOrders.cashOutSum.toLocaleString('ru-RU') }}</strong></p>
            </div>
            <div class="text-right">
              <CardBalance ref="cardsBalance" :date="getReportDate()"/>
              <button @click="() => openCardCashoutModal()" class="btn btn-outline-success btn-xs">обналичить карты
              </button>
            </div>
          </div>
          <button v-if="allowToEditCashOut" @click="() => openCardCashoutModal(balance.cards.end.cardsCashOut)"
                  type="button"
                  class="btn btn-outline-info btn-xs">редактировать
            обналичивание
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import moment from 'moment'
import EmptyCardModal from "@/components/modals/EmptyCardModal";
import api from "@/api";
import CardBalance from "@/views/reports/components/CardBalance.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";

export default {
  props: ['balance', 'useLocalCurrency', 'noCashOrders', 'refreshReport', 'dayData', 'exchanges', 'expenses', 'incomes', 'orders', 'useCashOut', 'division', 'divisions'],
  components: {
    LoadingButton,
    EmptyCardModal,
    CardBalance,
  },
  data() {
    return {
      calculatedData: {},
      totalCardsSum: 0,
      cashOut: 0,
      divisionCurrency: {id: 33, title: 'RUB'},
      btnBalanceLoading: false,
      allowToEditCashOut: false,
      cardCashoutModal: null,
      allowToCashoutCard: false,
      titles: {
        'cash': 'Конверт',
        'orders': 'Заявки',
        'salary': 'ЗП',
        'post': 'Почтовые р.',
      }
    }
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters['platform/currencies']
    },
    $AllStores() {
      return this.$store.getters['platform/stores'];
    },
  },
  created() {
    // if (this.useLocalCurrency) {
    if (this.$AllDivisions[this.division]?.settings?.currency_id) {
      const id = this.$AllDivisions[this.division].settings.currency_id;
      this.divisionCurrency = {
        id,
        title: this.$AllCurrencies[id].currency
      }
      // this.divisionCurrency.title = this.$AllCurrencies[this.divisionCurrency.id]?.currency;
    }
    // }
  },
  mounted() {
    // console.log('mounted');
    let total = {}
    Object.keys(this.balance.end ?? {}).forEach((curr) => {
      total[curr] = this.balance.end[curr].orders;
    });
    this.expenses.forEach((exp) => {
      if (!total[exp.currency_id]) {
        total[exp.currency_id] = 0;
      }
      total[exp.currency_id] -= exp.sum;
    })
    this.exchanges.forEach((exch) => {
      if (!total[exch.currency_id]) {
        total[exch.currency_id] = 0;
      }
      total[33] -= Math.round(exch.sum / exch.rate * 100) / 100;
      total[exch.currency_id] += exch.sum;
    })
    this.incomes.forEach((inc) => {
      if (!total[inc.currency_id]) {
        total[inc.currency_id] = 0;
      }
      if (inc.division_id == this.division) {
        total[inc.currency_id] -= inc.sum;
      } else {
        total[inc.currency_id] += inc.sum;
      }
    })
    this.calculatedData = total;
    this.totalCardsSum = (this.balance?.cards?.end?.totalSum ?? 0) + (this.balance?.cards?.start?.totalSum ?? 0);
    this.cashOut = this.balance?.cards?.end?.cardsCashOut?.sum ?? 0;
    if (this.totalCardsSum) {
      const today = moment(this.balance.start_date, 'YYYY-MM-DD').add(2, 'days');
      if (today > moment()) {
        this.allowToCashoutCard = true;
      }
    }
    if (this.balance?.cards?.end?.cardsCashOut?.isLastCashOut) {
      this.allowToEditCashOut = this.$currentRole === 'admin' || this.$currentUserRoles.includes('supervisor');
    }
  },
  methods: {
    getCurrencyBalance(amount) {
      const id = this.$AllDivisions[this.division]?.settings?.cross_currency_id ?? null;
      if (!id) return 0;
      return (amount / +(this.$AllCurrencies[id]?.rate ?? 1));
    },
    getReportDate() {
      return moment(this.balance.start_date).add(1, 'days').format('YYYY-MM-DD')
    },
    async updateCardsBalance() {
      this.btnBalanceLoading = true;
      await this.$refs.cardsBalance.collectBalance()
      this.btnBalanceLoading = false;
      this.cardCashoutModal.updateBalance = false;
    },
    getControlSum(calculateRemain = false) {
      const sum = this.totalCardsSum + (this.noCashOrders?.ordersInProgress?.total_sum || 0) + (this.noCashOrders?.incomesBySms || 0) - (this.$refs.cardsBalance?.totalAmount || 0);
      if (calculateRemain) {
        return +(this.cardCashoutModal.sum || 0) - sum;
      }
      return sum;
    },
    async saveCashOut() {
      // if (!this.cardCashoutModal.selectedCard) {
      //   toastr['warning']('Требуется выбрать карту');
      //   return;
      // }
      if (!this.cardCashoutModal.cashOut && (!this.cardCashoutModal.sum || this.cardCashoutModal.sum <= 0)) {
        toastr['warning']('Требуется ввести сумму');
        return;
      }
      if (this.cardCashoutModal.cashOut && this.cardCashoutModal.sum < 0) {
        toastr['warning']('Требуется ввести сумму');
        return;
      }
      // if (this.cardCashoutModal.sum > (this.balance.end[33].creditCards[this.cardCashoutModal.selectedCard] || 0)) {
      //   toastr['warning']('Сумма превышает остаток на карте');
      //   return;
      // }
      this.$refs.modalCard.acceptBtnLoading = true;
      const {data} = await api.post('/cards/cashout', {
        ...this.cardCashoutModal,
        remain: this.getControlSum(true)
      })
      if (data.success) {
        toastr['success']('Сохранено');
        if (this.refreshReport) {
          this.refreshReport();
        }
        this.cardCashoutModal = null;
      } else {
        toastr['warning'](data.message || 'Ошибка');
        if (data.updateBalance) {
          this.cardCashoutModal.updateBalance = true;
        }
      }
      this.$refs.modalCard.acceptBtnLoading = false;
    },
    openCardCashoutModal(cashOut = null) {
      this.cardCashoutModal = {
        header: cashOut ? 'Редактирование обраличивания' : 'Обналичивание доставочных карт',
        sum: cashOut ? cashOut.sum : 0,
        cashOut,
        selectedCard: 0,
      };
    },
    printNumber(num) {
      return num.substr(0, 4) + ' ' + num.substr(4, 4) + ' ' + num.substr(8, 4) + ' ' + num.substr(12);
    },
    getTotalSum() {
      const debug = false;
      const balance = Object.keys(this.balance.start).reduce((acc, c) => {
        acc[c] = this.balance.start[c].orders;
        return acc;
      }, {});

      let currentCurrencyId = this.divisionCurrency.id;

      if (!balance[currentCurrencyId]) {
        balance[currentCurrencyId] = 0;
      }
      if (debug) {
        console.log(balance);
        console.log(this.balance.cards?.start?.currentDivision?.totalSum || 0);
        console.log(this.orders.grouped.total_pass);
        console.log(this.orders.grouped.no_cash_total);
        console.log(this.cashOut || 0);
      }
      // let sum = 0;
      // this.orders.list.forEach((record) => {
      //   if (![3, 11].includes(record.status)) return;
      //   // if (debug){
      //   //   console.log(record.id, record.all_expenses, (record.courier_salary + record.post_sum), ((+record.extra_options.salary || 0) + (+record.extra_options.post_sum || 0)), record.all_expenses - ((+record.extra_options.salary || 0) + (+record.extra_options.post_sum || 0)));
      //   // }
      //   sum += (+record.price - +record.all_expenses);
      // console.log(balance[33]);
      balance[currentCurrencyId] -= this.balance.cards?.start?.currentDivision?.totalSum || 0;
      // console.log(balance[33]);
      balance[currentCurrencyId] += ((this.orders?.grouped?.total_pass ?? 0) - (this.orders?.grouped?.no_cash_total ?? 0));
      balance[currentCurrencyId] += (this.cashOut || 0);
      // console.log(balance[33]);
      // balance[33] -= this.orders.grouped.no_cash_total;
      // });
      if (debug) {
        console.log(balance);
      }
      this.expenses.forEach((e) => {
        if (!balance[e.currency_id]) {
          balance[e.currency_id] = 0;
        }
        // console.log('ex: ' + e.sum);
        balance[e.currency_id] -= e.sum;
      });
      if (debug) {
        console.log(balance);
      }
      this.exchanges.forEach((e) => {
        if (!balance[e.currency_id]) {
          balance[e.currency_id] = 0;
        }
        balance[e.currency_id] += +e.sum;
        balance[currentCurrencyId] -= (Math.round(e.sum / e.rate));
      });
      if (debug) {
        console.log(balance);
      }
      this.incomes.forEach((record) => {
        if (!balance[record.currency_id]) {
          balance[record.currency_id] = 0;
        }
        if (record.division_id == this.division) {
          balance[record.currency_id] -= record.sum;
        } else {
          balance[record.currency_id] += record.sum;
        }
      });
      // console.log(this.divisionCurrency, balance);
      // console.log(balance);
      // if (this.$AllDivisions[this.division]?.settings?.cross_currency_id) {
      //   Object.keys(balance).forEach((c) => {
      //     if (+c === this.$AllDivisions[this.division].settings.currency_id) {
      //       if (!balance[33]) balance[33] = 0;
      //       balance[33] += (Math.round(balance[c] / (this.$AllCurrencies[this.$AllDivisions[this.division].settings.cross_currency_id]?.rate ?? 1) * 10) / 10);
      //       balance[c] = 0;
      //     }
      //   });
      // }
      return balance;
    },
    getActualCashData() {
      let data = {};
      if (this.dayData.incashmentsData && this.dayData.incashmentsData.incashment) {
        data.cash = +this.dayData.incashmentsData.incashment.cash_amount;
        data.orders = +this.dayData.incashmentsData.incashment.adm_amount;
        data.salary = +this.dayData.incashmentsData.incashment.salary_amount;
        data.post = +this.dayData.incashmentsData.incashment.post_amount;
        const report = moment(this.dayData.incashmentsData.incashment.report_date);
        this.orders.list.forEach((o) => {
          if (moment(o.report_date) > report) {
            data.orders += (+o.price - +o.all_expenses);
            data.post += +o.extra_options.post_sum || 0;
            data.salary += +o.extra_options.salary || 0;
          }
        });
      } else {
        data.cash = +this.balance.start[33].cash;
        data.orders = +this.balance.start[33].orders + +(this.orders?.grouped?.total_pass ?? 0);
        data.post = +this.balance.start[33].post + +this.orders.grouped.total_post;
        data.salary = +this.balance.start[33].salary + +this.orders.grouped.total_salary;
      }
      return data;
    },
    moment: function (date, format) {
      if (!date) return;
      return moment(date).format(format);
    },
  }
}

</script>

<style scoped>
p {
  margin-bottom: 2px;
}

.figures {
  font-size: 20px;
}
</style>
